import React, { forwardRef } from 'react'
import { Input, NumberInput, Radio, Textarea } from '@mantine/core'
import CheckComp from '../components/Check'
import TitleComp from '../components/Title'
import ErrorTip from '../components/errorTip'
import BasicSettings from '../components/BasicSettings'
// 参数Controller, control, register
const Render = function ({
  watch,
  register,
  getValues,
  control,
  Controller,
  errors,
  // ...otherProps
}) {
  // console.log(otherProps, control, errors)
  const minLen = getValues('minlen')
  const maxLen = getValues('maxlen')
  const rule = {
    minLength: {
      value: minLen,
      message: `字数不可小于${minLen}`,
    },
    maxLength: {
      value: maxLen,
      message: `字数不可大于${maxLen}`,
    },
  }
  return (
    <BasicSettings register={register}>
      <TitleComp title="默认值">
        <div className="relative">
          {watch('render') === 'input' ? (
            <Input
              {...register('defaultValue', rule)}
              minLength={minLen}
              maxLength={maxLen}
            />
          ) : (
            <Textarea
              {...register('defaultValue', rule)}
              minLength={minLen}
              maxLength={maxLen}
            />
          )}
          <div className="absolute right-2 bottom-1.5">
            <span>
              {watch('minlen')}/{watch('maxlen')}
            </span>
          </div>
        </div>
      </TitleComp>
      {errors.defaultValue && (
        <ErrorTip errorMessage={errors.defaultValue.message} />
      )}
      <TitleComp title="选择渲染方式">
        <Controller
          name="render"
          control={control}
          render={({ field }) => {
            return (
              <Radio.Group
                styles={{
                  label: { color: 'var(--ow-color-gray-100)' },
                }}
                size="sm"
                required
                {...field}
              >
                <Radio value="input" label="单行文本框" />
                <Radio value="textarea" label="多行文本框" />
              </Radio.Group>
            )
          }}
        />
      </TitleComp>
      <TitleComp title="校验">
        <CheckComp
          register={register}
          registerName="required"
          // defaultValue={getValues('required')}
          label="必填"
        />
        <CheckComp
          register={register}
          registerName="rangeSetting"
          label="是否限制字数"
        />
        {watch('rangeSetting') && (
          <div className="flex  w-full">
            <div className="flex items-center ">
              <div className="mr-2">最少填写字数</div>
              <Controller
                name="minlen"
                control={control}
                render={({ field }) => {
                  return (
                    <NumberInput
                      {...field}
                      styles={{
                        input: { width: '100px' },
                      }}
                      placeholder="请填入字数最小限制"
                      min={0}
                      max={getValues('maxlen') - 1}
                      required
                    />
                  )
                }}
              />
            </div>

            <div className="flex items-center ml-4">
              <div className="mr-2">最多填写字数</div>
              <Controller
                name="maxlen"
                control={control}
                render={({ field }) => {
                  return (
                    <NumberInput
                      {...field}
                      styles={{
                        input: { width: '100px' },
                      }}
                      placeholder="请填入字数最大限制"
                      min={getValues('minlen') + 1}
                      required
                    />
                  )
                }}
              />
            </div>
          </div>
        )}
      </TitleComp>
    </BasicSettings>
  )
}

export default forwardRef(Render)
